import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { Paper } from 'components/UI';
import EChart from '../shared/EChart';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CreditStatusChart = function CreditStatusChart(_ref) {
  var creditCounts = _ref.creditCounts;
  var theme = useTheme();
  var option = useMemo(function () {
    if (!creditCounts) return null;
    var data = [{
      value: creditCounts.active || 0,
      name: 'Активни',
      itemStyle: {
        color: theme.success
      }
    }, {
      value: creditCounts.delayed || 0,
      name: 'Просрочени',
      itemStyle: {
        color: theme.error
      }
    }, {
      value: creditCounts.awaiting_approval || 0,
      name: 'Изчакващи',
      itemStyle: {
        color: theme.warning
      }
    }, {
      value: creditCounts.approved || 0,
      name: 'Одобрени',
      itemStyle: {
        color: theme.info
      }
    }, {
      value: creditCounts.draft || 0,
      name: 'Чернови',
      itemStyle: {
        color: theme.gray400
      }
    }, {
      value: creditCounts.payed || 0,
      name: 'Погасени',
      itemStyle: {
        color: '#8b5cf6'
      }
    }].filter(function (d) {
      return d.value > 0;
    });
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)'
      },
      legend: {
        bottom: 0,
        textStyle: {
          color: theme.gray500,
          fontSize: 11
        },
        itemWidth: 10,
        itemHeight: 10
      },
      series: [{
        type: 'pie',
        radius: ['45%', '70%'],
        center: ['50%', '45%'],
        avoidLabelOverlap: true,
        label: {
          show: true,
          position: 'center',
          fontSize: 22,
          fontWeight: 700,
          color: theme.gray800,
          formatter: function formatter() {
            var total = data.reduce(function (s, d) {
              return s + d.value;
            }, 0);
            return "".concat(total);
          }
        },
        emphasis: {
          scale: true,
          scaleSize: 6,
          label: {
            show: true,
            fontSize: 22,
            fontWeight: 700,
            color: theme.gray800,
            formatter: '{c}'
          }
        },
        data: data
      }]
    };
  }, [creditCounts, theme]);
  return ___EmotionJSX(Paper, {
    header: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0438",
    noPadding: true,
    padding: "1em"
  }, ___EmotionJSX(EChart, {
    option: option,
    height: 280
  }));
};

CreditStatusChart.propTypes = {
  creditCounts: PropTypes.object
};
export default CreditStatusChart;